var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import THEME_BREAKPOINTS from "../../config/theme/breakpoints";
import cx from "clsx";
import { Breakpoint, } from "./types";
import { buildDensities } from "../../../marketplace-next/src/utils/image/cloudinary";
import { FAKE_IMAGE } from "./constants";
var setSourcesImage = function (sourceProps, usePixelDensity) {
    var sources = __assign({}, sourceProps);
    if ("url" in sourceProps && "width" in sourceProps) {
        sources = __assign(__assign({}, sourceProps), { srcSet: usePixelDensity
                ? buildDensities(sourceProps.url)
                : sourceProps.url, url: undefined });
    }
    else {
        sources = __assign(__assign({}, sourceProps), { srcSet: usePixelDensity ? buildDensities(sourceProps.srcSet) : sourceProps.srcSet });
    }
    return sources;
};
var renderSource = function (bpValue, bpProps, index, usePixelDensity) {
    var sourceProps = typeof bpProps === "string" ? { srcSet: bpProps } : bpProps;
    var sources = setSourcesImage(sourceProps, usePixelDensity);
    return (React.createElement("source", __assign({}, sources, { media: "(max-width: " + (THEME_BREAKPOINTS[bpValue] - 1) + "px)", key: index })));
};
var filterSources = function (breakpoints, bp, desktopOnly, mobileOnly) {
    if (!breakpoints[bp]) {
        return false;
    }
    if (!desktopOnly && !mobileOnly) {
        return true;
    }
    var isMobileBreakpoint = bp === "sm";
    var isDesktopBreakpoint = ["lg", "xl"].includes(bp);
    return (isMobileBreakpoint && mobileOnly) || (isDesktopBreakpoint && desktopOnly);
};
/*
  we follow this trick to get a mobile or desktop-only image using a fake base 64 image
  https://medium.com/@mike_masey/how-to-use-the-picture-element-to-prevent-images-loading-on-mobile-devices-1376e33b190e
*/
export var Picture = function (_a) {
    var sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, alt = _a.alt, wrapperClassName = _a.wrapperClassName, _b = _a.usePixelDensity, usePixelDensity = _b === void 0 ? false : _b, _c = _a.desktopOnly, desktopOnly = _c === void 0 ? false : _c, _d = _a.mobileOnly, mobileOnly = _d === void 0 ? false : _d, _e = _a.className, className = _e === void 0 ? "" : _e, _f = _a.display, display = _f === void 0 ? "block" : _f, imgProps = __rest(_a, ["sm", "md", "lg", "xl", "alt", "wrapperClassName", "usePixelDensity", "desktopOnly", "mobileOnly", "className", "display"]);
    var breakpoints = { sm: sm, md: md, lg: lg, xl: xl };
    var srcSet = usePixelDensity ? buildDensities(imgProps.src) : null;
    var imgClassName = cx({
        "hidden md:block": desktopOnly && display === "block",
        "block md:hidden": mobileOnly && !desktopOnly && display === "block",
        "hidden md:inline-block": desktopOnly && display === "inline-block",
        "inline-block md:hidden": mobileOnly && !desktopOnly && display === "inline-block",
        "hidden md:inline": desktopOnly && display === "inline",
        "inline md:hidden": mobileOnly && !desktopOnly && display === "inline",
    }, className);
    return (React.createElement("picture", { className: wrapperClassName },
        desktopOnly && (React.createElement(React.Fragment, null,
            React.createElement("source", { media: "(max-width: " + (THEME_BREAKPOINTS[Breakpoint.md] - 1) + "px)", sizes: "1px", srcSet: FAKE_IMAGE + " 1w" }),
            React.createElement("source", { media: "(min-width: " + THEME_BREAKPOINTS[Breakpoint.md] + "px)", srcSet: srcSet, src: imgProps.src }))),
        mobileOnly && !desktopOnly && (React.createElement(React.Fragment, null,
            React.createElement("source", { media: "(min-width: " + THEME_BREAKPOINTS[Breakpoint.md] + "px)", sizes: "1px", srcSet: FAKE_IMAGE + " 1w" }),
            React.createElement("source", { media: "(max-width: " + (THEME_BREAKPOINTS[Breakpoint.md] - 1) + "px)", srcSet: srcSet, src: imgProps.src }))),
        Object.keys(breakpoints)
            .filter(function (bp) { return filterSources(breakpoints, bp, desktopOnly, mobileOnly); })
            .map(function (bp, index) { return renderSource(bp, breakpoints[bp], index, usePixelDensity); }),
        React.createElement("img", __assign({ alt: alt }, imgProps, { srcSet: srcSet, className: imgClassName }))));
};
//# sourceMappingURL=Picture.js.map